import React from 'react';
import * as LucideIcons from 'lucide-react';
import ReactPlayer from 'react-player';
import { useTranslation } from 'react-i18next';

const UniversalMediaViewer = ({ mediaData, onClose }) => {
    const { t } = useTranslation();
    if (!mediaData) return null;

    const renderContent = () => {
        const isVideo = ReactPlayer.canPlay(mediaData.url);

        if (isVideo) {
            return (
                <ReactPlayer
                    url={mediaData.url}
                    controls={true}
                    playing={true}
                    width="100%"
                    height="100%"
                />
            );
        }
        
        // Assume it's an image if not a video
        return <img src={mediaData.url} alt={t('universalMediaViewer.altText')} className="max-w-full max-h-full rounded-lg object-contain" />;
    };

    return (
        <div className="modal-overlay animate-fadeIn" onClick={onClose}>
            <div className="relative max-w-4xl max-h-[90vh] w-full h-full flex items-center justify-center" onClick={e => e.stopPropagation()}>
                <button onClick={onClose} className="absolute -top-10 right-0 md:top-2 md:-right-12 p-2 rounded-full bg-gray-700/50 hover:bg-gray-600/50 text-white transition duration-300" aria-label={t('universalMediaViewer.closeAriaLabel')}>
                    <LucideIcons.X size={24} />
                </button>
                {renderContent()}
            </div>
        </div>
    );
};

export default UniversalMediaViewer;
